export default __webpack_public_path__ + "static/media/icon-checkmark.a6590100.svg";